import React from 'react';
import styled from 'styled-components';

const Loader = styled.div`
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin .03s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingContainer = styled.div`
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10px;
`;

export function LoadingSpinner() {
  return (
    <LoadingContainer>
      <center> 
        <Loader />
      </center>
    </LoadingContainer>
  );
}

export function BootstrapSpinner({ message = "Loading..." }) {
  return (
    <LoadingContainer>
      <center> 
        <div className="spinner-border" role="status">
          <span className="visually-hidden">{message}</span>
        </div>
        {message && <p className="mt-3">{message}</p>}
      </center>
    </LoadingContainer>
  );
}
